import { Box, LoadingOverlay } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { sendOutput, sendSignal } from '@shared/port-send-v1.0.0'
import { forwardRef, useEffect, useImperativeHandle } from 'react'
import type { Props } from '../node/definition'

export default forwardRef((p: Props, ref) => {
	const [isVisible, { open, close, toggle }] = useDisclosure(false)

	useImperativeHandle(
		ref,
		() => ({
			toggle: () => toggle(),
			show: () => open(),
			hide: () => close(),
		}),
		[isVisible]
	)

	useEffect(() => {
		if (p.isVisible) open()
		if (p.isVisible === false) close()
	}, [p.isVisible])

	useEffect(() => {
		sendOutput(p.noodlNode, 'visible', isVisible)
		if (isVisible) sendSignal(p.noodlNode, 'shown')
		else sendSignal(p.noodlNode, 'hid')
	}, [isVisible])

	return (
		<Box pos="relative" {...p.customProps}>
			<LoadingOverlay {...p} {...p.customProps} visible={isVisible} />
			{p.children}
		</Box>
	)
})
